import {useCalculatorWindowStore} from './calculatorWindow.store';

/**
 * One gate for every calculator surface: the toolbar button that opens the
 * window and the window itself both call this, so the entry point can never
 * offer something the window would refuse to show. The practice view hosting
 * the window decides through the store's `tier`.
 */
export function useIsCalculatorAvailable(): boolean {
  return useCalculatorWindowStore((state) => state.tier) !== 'none';
}
